export const FACTORY_CHECKPOINT_PERMISSIONS = {
    //New Factory Permissions
    1: "update_damage_valve",
    2: "update_cap_present",
    3: "update_cylinder_color",
    4: "update_leakage_type_color",
    5: "update_wear_tear_color",
    6: "update_sandblast_required",
    7: "update_gas_found",
    8: "update_weight_before_degas",
    9: "update_degassing_done",
    10: "update_weight_after_degas",
    11: "update_last_hydro_date",
    12: "update_hydro_required",
    13: "update_original_weight",
    14: "update_valve_dismantling",
    15: "update_cylinder_inversion",
    16: "update_slug_found",
    17: "update_slug_cleaning",
    18: "update_water_found",
    19: "update_water_cleaning",
    20: "update_rejected_valve_fit",
    21: "update_tare_weight",
    22: "update_hydro_testing",
    23: "update_sandblast_done",
    24: "update_paint_done",
    25: "update_valve_fitting",
    26: "update_vacuum_achieved",
    27: "update_filling_done",
    28: "update_ammonia_temp_check",
    29: "update_ammonia_temp_check_2hr",
    30: "update_cap_fit_done",
    31: "update_final_ammonia_temp_check",
};
